import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { PermissionSetContainerModel } from '../../../../../models/aggregates/permissions';
import { ApiResponseModel, ApiVisa } from '../shared';
import { Observable } from 'rxjs';

// https://api.akaun.dev/core2/tnt/dm/app-permission-sets/assignee-target/backoffice-ep

@Injectable({
  providedIn: 'root'
})
export class PermissionSetAssigneeTargetService extends BaseApiTemplateService<PermissionSetContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-permission-sets/assignee-target/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +'iam/app-permission-sets/assignee-target/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }

  public permissionSetAssigneeTargetAllocation(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
        this.apiUrl,
        dtoObject,
        this.getHttpHeader(visa)
    );
  }
}
